<template>
  <Fragment>
    <template v-if="$route.name !== 'showScanInfo'">
      <router-view></router-view>
    </template>
    <section class="container" v-else>
      <Breadcrumb />
      <div class="card-wrap mt-20 mb-20">
        <section class="card-content">
          <el-tag type="success" effect="dark"
            >{{ systemSourceName }} > {{ sceneSource }} > {{ typeName }}</el-tag
          >
          <div class="right">
            <el-button type="primary" class="mr-20" @click="exportScanInfo"
              >导出</el-button
            >
          </div>
        </section>
      </div>
      <el-table :data="list" border>
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            <span>{{ scope.$index + (pageNum - 1) * pageSize + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="码图内容"
          width="500"
          show-overflow-tooltip
          class="el-tooltip__popper"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.oidContent }}</span>
          </template>
        </el-table-column>
        <el-table-column label="品牌" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.brandCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="线体编码" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.productLineCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="线体名称" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.productLineName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="生码时间" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.qrCreatetime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="原因描述"
          show-overflow-tooltip
          class="el-tooltip__popper"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.remark }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20 pagination"
        background
        layout="total,prev, pager, next, jumper"
        :total="total"
        :page-size="10"
        :current-page="pageNum"
        @prev-click="handlePrePage"
        @next-click="handleNextPage"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

import Breadcrumb from "@/components/Breadcrumb";

export default {
  name: "role",
  components: {
    Breadcrumb,
    Fragment
  },
  data() {
    return {
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      systemSourceName: "",
      sceneSource: "",
      typeName: "扫码失败量",
      type: "",
      year: "",
      month: ""
    };
  },
  methods: {
    getScanInfo() {
      let _this = this;
      let param = {
        url: "/api/shoot/getShootInfoPage",
        params: {
          pageNum: _this.pageNum,
          pageSize: _this.pageSize,
          sceneSource: _this.sceneSource,
          systemSource: _this.systemSource,
          year: _this.year,
          month: _this.month,
          type: _this.type
        }
      };
      _this.$store.dispatch("getShootInfoPage", param).then(() => {
        _this.list = _this.$store.state.scanStatistics.scanFailInfo.list;
        _this.total = _this.$store.state.scanStatistics.scanFailInfo.total;
      });
    },
    //当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.pageNum = value;
      _this.getScanInfo();
    },
    //上一页
    handlePrePage() {
      let _this = this;
      _this.pageNum -= 1;
      _this.getScanInfo();
    },
    //下一页
    handleNextPage() {
      let _this = this;
      _this.pageNum += 1;
      _this.getScanInfo();
    },
    exportScanInfo() {
      let _this = this;
      let param = {
        sceneSource: _this.sceneSource,
        systemSource: _this.systemSource,
        year: _this.year,
        month: _this.month,
        type: _this.type
      };
      _this.$Api.post("/api/shoot/exportShootInfo", param).then(response => {
        if (response.status === 200) {
          _this.$Api.exportExcel(
            [
              "码图内容",
              "品牌",
              "线体编码",
              "线体名称",
              "生码时间",
              "原因描述"
            ],
            [
              "oidContent",
              "brandCode",
              "productLineCode",
              "productLineName",
              "qrCreatetime",
              "remark"
            ],
            response.data,
            _this.systemSourceName +
              "_" +
              _this.sceneSource +
              "_" +
              _this.typeName
          );
        } else {
          _this.$message({
            message: "无法获取导出数据",
            type: "warning"
          });
        }
      });
    },
    getSystemSourceName(val) {
      if (val === "AfterSale-iMaker-Android") {
        return "售后-爱创客-安卓端";
      } else if (val === "AfterSale-iMaker-iOS") {
        return "售后-爱创客-苹果端";
      } else if (val === "Casarte") {
        return "卡萨帝";
      } else if (val === "EDW") {
        return "集团数据仓库";
      } else if (val === "afterAale") {
        return "售后";
      } else if (val === "cosmo") {
        return "cosmo";
      } else if (val === "smartHome") {
        return "智家";
      } else if (val === "smartHomePublic") {
        return "智家公众号";
      } else {
        return val;
      }
    },
    getScanType(type) {
      if (type === 2) {
        return "i码制扫码失败量";
      } else if (type === 3) {
        return "MA码制扫码失败量";
      } else {
        return "扫码失败量";
      }
    }
  },
  created() {
    let _this = this;
    _this.systemSourceName = _this.getSystemSourceName(
      _this.$route.query.systemSource
    );
    _this.sceneSource = _this.$route.query.sceneSource;
    _this.systemSource = _this.$route.query.systemSource;
    _this.year = _this.$route.query.year;
    _this.month = _this.$route.query.month;
    _this.type = _this.$route.query.type;
    _this.typeName = _this.getScanType(_this.$route.query.type);
    _this.getScanInfo();
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
  .card-content
    display: flex
    align-items: center
    justify-content: space-between
    .left
      display: flex
    .el-button
      font-size: 14px
    .search-name, .search-code
      font-size: 14px
      display: flex
      align-items: center
      span
        white-space: nowrap
.pagination
  text-align: center
</style>
